import { USNAccount } from '../types'

export const getUSNs = (): USNAccount[] => {
    return [
        {
            usnAccountId: 1,
            usnAccountMeta: '433 Hamptons, New York, NY, 10014, USA',
            usnAccountName: '8573679484',
            facilityAddress: {
                address1: '200 W Demo Ave',
                city: 'Bentonville',
                state: 'AR',
                country: 'United States',
                zip: '72712',
            },
        },
        {
            usnAccountId: 2,
            usnAccountMeta: '304 Cooper Street, New York, NY, 10014, USA',
            usnAccountName: '7576837476',
            facilityAddress: {
                address1: '200 W Demo Ave',
                city: 'Bentonville',
                state: 'AR',
                country: 'United States',
                zip: '72712',
            },
        },
        {
            usnAccountId: 3,
            usnAccountMeta: '101 Independence Street, New York, NY, 10014, USA',
            usnAccountName: '7659384923',
            facilityAddress: {
                address1: '200 W Demo Ave',
                city: 'Bentonville',
                state: 'AR',
                country: 'United States',
                zip: '72712',
            },
        },
        {
            usnAccountId: 4,
            usnAccountMeta: '103 Independence Street, New York, NY, 10014, USA',
            usnAccountName: '9352748927',
            facilityAddress: {
                address1: '200 W Demo Ave',
                city: 'Bentonville',
                state: 'AR',
                country: 'United States',
                zip: '72712',
            },
        },
        {
            usnAccountId: 5,
            usnAccountMeta: '105 Independence Street, New York, NY, 10014, USA',
            usnAccountName: '3457684562',
            facilityAddress: {
                address1: '200 W Demo Ave',
                city: 'Bentonville',
                state: 'AR',
                country: 'United States',
                zip: '72712',
            },
        },
        {
            usnAccountId: 6,
            usnAccountMeta: '107 Independence Street, New York, NY, 10014, USA',
            usnAccountName: '9347684583',
            facilityAddress: {
                address1: '200 W Demo Ave',
                city: 'Bentonville',
                state: 'AR',
                country: 'United States',
                zip: '72712',
            },
        },
    ]
}
